import { Inject, Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Router } from '@angular/router'
import { timer, Observable, Subject } from 'rxjs'

import { ICustomerAccountValidationResult } from '../types/customerAccountValidationResult'
import { MessageService } from './message.service'

@Injectable({
  providedIn: 'root'
})
export class SiteService 
{
	private loginAttempts: number = 0
	private sessionTimeoutSeconds: number = 0
	private sessionIntervalTimer: any = {}
	private _customerAccount: ICustomerAccountValidationResult | undefined = undefined

	get customerAccount(): ICustomerAccountValidationResult | undefined {
		return this._customerAccount
	}
	set customerAccount(c : ICustomerAccountValidationResult) {
		this._customerAccount = c
	}

	public isLockedOut: boolean = false
	//public isChatOpen: boolean = false
	public customerRequestType: number = 0
	public viewParameters: any = {}

	public daysFR: { [key: string]: string } = {
		'Sunday': 'Dimanche', 'Monday': 'Lundi', 'Tuesday': 'Mardi', 'Wednesday': 'Mercredi', 
		'Thursday': 'Jeudi', 'Friday': 'Vendredi', 'Saturday': 'Samedi'}

	public monthsFR: { [key: string]: string } = {
		'January': 'Janvier', 'February': 'Février', 'March': 'Mars',
		'April': 'Avril', 'May': 'Mai', 'June': 'Juin',
		'July': 'Juillet', 'August': 'Août', 'September': 'Septembre',
		'October': 'Octobre', 'November': 'Novembre', 'December': 'Décembre'}

	constructor(
		private http: HttpClient,
		//@Inject('CHAT_API_URL') private chatUrl: string,
		private router: Router,
		private messageService: MessageService
	) 
	{ 
		this._customerAccount = <ICustomerAccountValidationResult>
		{
			accountKnowledgeValidated: false,
			customerValidationKey: '',
			serialNumber: '',
			accountNumber: '',
			paymentAmount: 0,
			customerId: 0,
			fullName: '',
			isActiveLease: false,
			sessionExpiry: new Date()
		}
  	}

	// getHttpHeaders()
	// {
	// 	return new HttpHeaders({
	// 		'Content-Type': 'application/json',
	// 		'Accept': 'application/json'
	// 	})
	// }

	// getChatAvailability(): Observable<any>
	// {
	// 	return this
	// 		.http
	// 		.get<any>(this.chatUrl + 'Chat/IsScheduleGroupOpen/37ea0d72-e64a-46d8-97e1-e5ed35a061d7', { headers: this.getHttpHeaders() })
	// 		.pipe()
	// }

	setLoginSession(customerAccountValidationResult: ICustomerAccountValidationResult, routeName: string | undefined): void
	{
		let nextRoute: string = ''

		this._customerAccount = undefined
		this._customerAccount = customerAccountValidationResult

		this.clearSessionTimers()

		if (customerAccountValidationResult.accountKnowledgeValidated)
		{	
			this.loginAttempts = 0

			this.setSessionTimers()

			if (routeName !== undefined)
			{
				nextRoute = routeName
			}
			else
			{
				nextRoute = '/validate-account'				
			}
		}
		else
		{
			this.loginAttempts = this.loginAttempts + 1

			if(this.loginAttempts > 2)
			{
				this.isLockedOut = true

				timer(2000000).subscribe(() => { //lock for 30mins
					this.loginAttempts = 0
					this.isLockedOut = false
				})
			}

			nextRoute = '/validate-account'
		}

		if (this.router.url != nextRoute)
		{
			this
				.router
				.navigate([nextRoute])
				.then(nav =>
				{
					console.log(`router.navigate() ${nav}`)
					if (!nav)
					{
						this.router.navigate([''])
					}
				})
				.catch(error =>
				{
					console.log(`router.navigate() error: ${error}`);
				})
		}
	}

	updateLoginSession(customerAccountValidationResult: ICustomerAccountValidationResult): void
	{
		this._customerAccount = customerAccountValidationResult

		if (!this._customerAccount.accountKnowledgeValidated)
		{
			this.setLoginSession(customerAccountValidationResult, undefined)
		}
		else
		{
			this.loginAttempts = 0
			this.clearSessionTimers()
			this.setSessionTimers()
		}
	}

	logout(): void
	{
		this.clearSessionTimers()

		this._customerAccount = undefined
		this._customerAccount = {
			accountKnowledgeValidated: false,
			customerValidationKey: '',
			serialNumber: '',
			accountNumber: '',
			paymentAmount: 0,
			customerId: 0,
			fullName: '',
			isActiveLease: false,
			sessionExpiry: new Date()
		}

		this.router.navigate(['/'])
	}

	countdownSession()
	{
		this.sessionTimeoutSeconds--

		// let sessionTimeout = new Date(this.sessionTimeoutSeconds * 1000)
		// let minutes = sessionTimeout.getUTCMinutes()
		// let seconds = sessionTimeout.getUTCSeconds()
		// let displatyminutes = (minutes.toString().length == 1) ? '0' + minutes : minutes
		// let displayseconds = (seconds.toString().length == 1) ? '0' + seconds : seconds

		// document.title = displatyminutes + ':' + displayseconds

		if (this.sessionTimeoutSeconds <= 0)
		{
			this.clearSessionTimers()

			this._customerAccount = undefined
			this._customerAccount = {
				accountKnowledgeValidated: false,
				customerValidationKey: '',
				serialNumber: '',
				accountNumber: '',
				paymentAmount: 0,
				customerId: 0,
				fullName: '',
				isActiveLease: false,
				sessionExpiry: new Date()
			}
			
			if (this.router.url != '/' && 
				this.router.url != '/about-us' &&
				this.router.url != '/lessees-faq' &&
				this.router.url != '/join-the-cdlsi-team' &&
				this.router.url != '/contact-us'&&
				this.router.url != '/privacy-policy'&&
				this.router.url != '/aoda-multi-year-accessibility-plan'&&
				this.router.url != '/accessible-customer-service-policy'&&
				this.router.url != '/request-status' &&
				this.router.url != '/request-list' &&
				this.router.url != '/customer-intent')
			{
				this.router.navigate(['/'])
				this.messageService.loginSessionExpired()
			}
		}
	}

	clearSessionTimers()
	{
		if (this.sessionIntervalTimer != undefined)
		{
			window.clearInterval(this.sessionIntervalTimer)
			this.sessionIntervalTimer = undefined
		}
	}

	setSessionTimers()
	{
		if (this.customerAccount) 
		{
			this.sessionTimeoutSeconds = this.sessionDurationSeconds(this.customerAccount.sessionExpiry)
		}

		this.sessionIntervalTimer = window.setInterval(() => this.countdownSession(), 1000)
	}

	sessionDurationSeconds(expiryTime: Date | undefined) : number
	{
		if (!expiryTime) return 0

		let t1 = new Date(expiryTime)
		let t2 = new Date()

		let timeDiff = t1.getTime() - t2.getTime()
		let durationSeconds = timeDiff / 1000

		return Math.abs(durationSeconds)
	}

	printHtmlElement(elementId: string, title: string)
	{
		var printContents = document.getElementById(elementId)?.innerHTML ?? ''
		var popupWin: Window | null

		if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1)
		{
			popupWin = window.open('', '_blank', 'width=800,height=600,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no')
			if (!popupWin) return false
			popupWin.window.focus()
			popupWin.document.write('<title>' + title + '</title>')
			popupWin.document.write('<!DOCTYPE html><html><head></head><body onload="window.print()"><div>' + '<h4>' + title + '</h4>' + printContents + '</div></html>')
			popupWin.onbeforeunload = function () {
				popupWin!.close()
				return '.\n'
			}
			popupWin.onabort = function () {
				popupWin!.document.close()
				popupWin!.close()
			}
		}
		else
		{
			popupWin = window.open('', '_blank', 'width=800,height=600')
			if (!popupWin) return false
			popupWin.document.open()
			popupWin.document.write('<title>' + title + '</title>')
			popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + '<h4>' + title + '</h4>' + printContents + '</html>')
			popupWin.document.close()
		}
		popupWin.document.close()

		return true
	}

	// killChat()
	// {
	// 	try
	// 	{
	// 		//@ts-ignore
	// 		window.customPlugin.command('WebChat.close')
	// 		setTimeout(() => $('.cx-close-confirm').trigger('click'), 10)
	// 	}
	// 	catch(e){ console.log(e) }
	// }
}
